module.exports = __webpack_public_path__ + "img/bgIDcard.96058d20.png";